///<reference path="./smart-mover.models.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    interface IPossibleStateEnums {
        objectStateEnum?: ObjectStateEnum;
        objectState?: ObjectStateEnum;
    }

    export class SmartMoverModel<T extends IPossibleStateEnums> implements ISmartMoverModel<T> {
        disabled: boolean;
        protected _selected: boolean;
        protected readonly _collection: ICollectionBase<T>;
        protected readonly attributes: T;

        get collection(): ICollectionBase<T> {
            return this._collection;
        }

        get className() {
            return {
                'text-italic': !this.isActive
            };
        }

        get template(): string {
            return 'app/components/controls/smart-mover/views/model.html';
        }

        get selected(): boolean {
            return this._selected;
        }

        set selected(value: boolean) {
            this._selected = value;
        }

        get id(): string {
            return this.attributes[this.options.idKey];
        }

        get displayName(): string {
            return `${this.attributes[this.options.displayNameKey]}${((this.options.showInactiveLabel && !this.isActive) ? this.options.inactiveLabel : '')}`;
        }

        get isActive(): boolean {
            if (this.get('objectStateEnum') === undefined && this.get('objectState') === undefined) return true;

            return this.get('objectStateEnum') === ObjectStateEnum.Active
                || this.get('objectState') === ObjectStateEnum.Active;
        }

        constructor(attributes: T, protected options: IModelOptions<T>) {
            this.attributes = attributes;
            this._collection = options.collection;
        }

        get<K extends keyof T>(key: K): T[K] {
            return this.attributes[key];
        }

    }
}
